module.exports = __webpack_public_path__ + "img/tshirt-front.5630f14a.svg";